(() => {
  const configNode = document.getElementById('jljb-embroidery-config');
  const root = window.Shopify?.routes?.root || '/';
  const productId = '10044966699248';
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:config.currency || 'USD'}).format(cents / 100);
  let variant = config.variant;
  let pending = false;
  let busy = false;
  let panel;
  let form;
  const choices = new Map();
  const make = (tag, text, className) => {
    const node = document.createElement(tag);
    if (text !== undefined) node.textContent = text;
    if (className) node.className = className;
    return node;
  };
  const getForm = () => document.querySelector('product-form-component[data-product-id="' + productId + '"] form');
  const currentVariant = () => {
    const picker = document.querySelector('variant-picker[data-product-id="' + productId + '"]');
    const data = picker?.querySelector('script[type="application/json"]');
    if (data) { try { return JSON.parse(data.textContent); } catch {} }
    return variant;
  };
  function update() {
    if (!panel?.isConnected) return;
    const primary = variant?.option2 || '';
    for (const [name, choice] of choices) {
      const included = name === primary;
      if (included) choice.check.checked = false;
      choice.check.disabled = included || pending || busy;
      choice.details.hidden = !choice.check.checked;
      choice.status.textContent = included ? 'Included as primary' : '+' + money(choice.price);
    }
    const qty = Math.max(1, Number(form?.querySelector('[name="quantity"]')?.value || 1));
    const selected = [...choices].filter(([,c]) => c.check.checked);
    const extra = selected.reduce((sum,[,c]) => sum + c.price, 0);
    panel.querySelector('[data-primary]').textContent = pending ? 'Updating garment price…' : (variant?.title || '') + ' — ' + money(variant?.price || 0);
    panel.querySelector('[data-breakdown]').textContent = selected.length ? selected.map(([name,c]) => name + ' +' + money(c.price)).join(' · ') : 'No additional placements selected.';
    panel.querySelector('[data-total]').textContent = 'Total: ' + money(((variant?.price || 0) + extra) * qty) + (qty > 1 ? ' for ' + qty + ' garments' : ' per garment');
    if (window.JLJBDigitizing) window.JLJBDigitizing.render(panel, (variant?.price || 0) + extra, qty, money);
  }
  function init() {
    const next = getForm();
    if (!next || (form === next && panel?.isConnected)) return;
    form = next;
    if (panel) panel.remove();
    panel = make('div', undefined, 'jljb-embroidery');
    panel.append(make('h2','Embroidery pricing & additional placements'));
    panel.append(make('p','Your garment price includes the primary placement selected above. Add any other placements below for $7 each, per garment.'));
    const primary = make('p', '', 'jljb-embroidery-primary'); primary.dataset.primary = ''; panel.append(primary);
    const fieldset = make('fieldset'); fieldset.append(make('legend','Additional placements — select all that apply'));
    if (!Array.isArray(config.addons) || config.addons.length !== 6) {
      panel.append(make('p','Additional placements are temporarily unavailable. Please contact us before ordering.'));
    } else for (const addon of config.addons) {
      const name = addon.option1 || addon.title;
      const previous = choices.get(name);
      const row = make('div',undefined,'jljb-embroidery-choice');
      const label = make('label');
      const check = document.createElement('input'); check.type = 'checkbox'; check.checked = previous?.check.checked || false; check.setAttribute('aria-label', name + ' additional placement');
      const status = make('span','+' + money(addon.price),'jljb-embroidery-price');
      label.append(check,make('span',name),status); row.append(label);
      const details = make('div',undefined,'jljb-embroidery-details'); details.hidden = !check.checked;
      const textLabel = make('label',name + ' design, text or wording');
      const text = make('textarea'); text.rows=2; text.maxLength=500; text.value=previous?.text.value || ''; textLabel.append(text); details.append(textLabel);
      let style;
      if (name.includes('Sleeve')) {
        const styleLabel = make('label','Sleeve layout');
        style = make('select');
        for (const title of ['Standard sleeve embroidery','Full sleeve wording (shoulder to wrist)']) {
          const option=make('option',title); option.value=title; style.append(option);
        }
        style.value=previous?.style?.value || 'Standard sleeve embroidery';
        styleLabel.append(style); details.prepend(styleLabel);
      }
      row.append(details); fieldset.append(row);
      choices.set(name,{id:addon.id,price:addon.price,check,status,details,text,style});
      check.addEventListener('change',update);
    }
    panel.append(fieldset);
    const instructionsLabel=make('label','Primary placement instructions (optional)');
    const instructions=make('textarea'); instructions.rows=2; instructions.maxLength=500; instructions.dataset.primaryInstructions='';
    instructions.placeholder='For sleeve wording, specify shoulder-to-wrist layout and exact text.';
    instructionsLabel.append(instructions); panel.append(instructionsLabel);
    const summary=make('div',undefined,'jljb-embroidery-summary'); summary.setAttribute('aria-live','polite'); summary.setAttribute('aria-atomic','true');
    const breakdown=make('p'); breakdown.dataset.breakdown=''; const total=make('p',undefined,'jljb-embroidery-total'); total.dataset.total='';
    summary.append(breakdown,total,make('small','Before shipping, taxes and any checkout discounts.')); panel.append(summary);
    const error=make('p',undefined,'jljb-embroidery-error'); error.dataset.error=''; error.setAttribute('role','alert'); panel.append(error);
    const button=form.querySelector('add-to-cart-component');
    (button?.parentElement || form).insertBefore(panel,button || null);
    update();
  }
  document.addEventListener('variant:selected',event => {
    if (!event.target.closest?.('variant-picker[data-product-id="' + productId + '"]')) return;
    pending=true; update();
  });
  document.addEventListener('variant:update',event => {
    if (String(event.detail?.data?.productId) !== productId) return;
    variant=event.detail.resource; pending=false; init(); update();
  });
  document.addEventListener('change',event => {
    if (event.target.closest?.('product-form-component[data-product-id="' + productId + '"]')) update();
  });
  document.addEventListener('input',event => {
    if (event.target.name === 'quantity') update();
  });
  window.addEventListener('submit',async event => {
    const target=event.target;
    if (!(target instanceof HTMLFormElement) || target !== getForm()) return;
    event.preventDefault(); event.stopImmediatePropagation();
    init();
    const error=panel.querySelector('[data-error]');
    error.textContent='';
    if (pending || busy) { error.textContent='Please wait for the selected garment price to update.'; return; }
    if (!target.reportValidity() || target.classList.contains('uploadkit-invalid')) {
      error.textContent='Please complete the garment color, thread color and any required customization fields above.';
      target.querySelector('.uploadkit-invalid-field, [invalid]')?.scrollIntoView({block:'center',behavior:'smooth'});
      return;
    }
    variant=currentVariant();
    if (!variant?.available) { error.textContent='This configuration is currently unavailable.'; return; }
    const data=new FormData(target);
    const quantity=Math.max(1,Number(data.get('quantity') || 1));
    const properties={};
    for (const [key,value] of data.entries()) {
      const match=key.match(/^properties\[(.*)\]$/);
      if (match && typeof value === 'string' && value) properties[match[1]]=value;
      if (value instanceof File && value.size) { error.textContent='Please finish uploading your artwork before adding to cart.'; return; }
    }
    const group=crypto.randomUUID();
    properties['_Embroidery configuration']=group;
    const primaryNotes=panel.querySelector('[data-primary-instructions]').value.trim();
    if (primaryNotes) properties['Primary placement instructions']=primaryNotes;
    const items=[{id:variant.id,quantity,properties}];
    for (const [name,choice] of choices) {
      if (!choice.check.checked || name === variant.option2) continue;
      const childProperties={'Placement':name,'Garment':variant.option3,'Size':variant.option1,'_Embroidery configuration':group};
      if (choice.text.value.trim()) childProperties['Design / wording']=choice.text.value.trim();
      if (choice.style) childProperties['Sleeve layout']=choice.style.value;
      items.push({id:choice.id,quantity,parent_id:variant.id,properties:childProperties});
    }if (window.JLJBDigitizing) items.push(...window.JLJBDigitizing.cartItems(variant.id, group));
    busy=true; update();
    const buttons=[...target.querySelectorAll('[type="submit"]')]; buttons.forEach(button=>button.disabled=true);
    try {
      const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
      const result=await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || 'Unable to add this configuration. Please try again.');
      window.location.assign(root+'cart');
    } catch (failure) {
      error.textContent=failure.message || 'Unable to add this configuration. Please try again.';
      busy=false; buttons.forEach(button=>button.disabled=false); update();
    }
  },true);
  init();
  new MutationObserver(()=>{init();}).observe(document.getElementById('MainContent') || document.body,{childList:true,subtree:true});
})();